import { HttpClient } from "@angular/common/http";
import { Injectable, inject, signal } from "@angular/core";
import { RoleNameData } from "@shared/models/user-data";
import { Observable, map, of } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class RollService {
    private readonly http = inject(HttpClient);


    public getAll(): Observable<RoleNameData[]> {
        const url = "api/role/getAll";
        return this.http.get<RoleNameData[]>(url);
    }

    private _userRoles = signal<string[]>([]);
    private _isAdmin = signal<boolean|null>(null);

    public getUserRoles(): Observable<string[]> {
        if (this._userRoles().length > 0) {
            return of(this._userRoles());
        } 
        else {
            const url = "api/role/getUserRoles";
            return this.http.get<string[]>(url).pipe(map(roles => {
                this._userRoles.set(roles); //Spara roller i service innan de returneras
                return roles;
            }));
        }
    }

    public userIsAdmin(): Observable<boolean> {
        const savedIsAdmin = this._isAdmin();
        if (savedIsAdmin != null) {
            return of(savedIsAdmin);
        } 
        else {
            return this.getUserRoles().pipe(map(roles => {
                const isAdmin = (roles.indexOf("admin") > -1);
                this._isAdmin.set(isAdmin); //Spara "isAdmin" i service innan det returneras
                return isAdmin;
            }));
        }
    }

    public getUserUnits(): Observable<any[]> {
        const url = "api/role/getUserUnits";
        return this.http.get<any[]>(url);
    }

}
